export default __webpack_public_path__ + "static/media/weightlosswithfamily_1@2x.e4193b6a.jpg";